import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './Accordion.scss'

export const ACCORDION_VARIANT_DEFAULT = 'default'
export const ACCORDION_VARIANT_LIGHT = 'light'
export const ACCORDION_VARIANT_STRONG = 'strong'

export const Accordion = ({
  children,
  className,
  defaultExpanded,
  label,
  note,
  variant,
  onExpandCollapse,
  'data-mu-test': dataAttributeTest
}) => {
  const [collapsed, setCollapsed] = useState(!defaultExpanded)
  const collapsibleElement = useRef(null)

  function handleClick() {
    setCollapsed(prev => !prev)
  }

  useEffect(() => {
    if (!collapsed) {
      collapsibleElement.current.style.height = `${collapsibleElement.current.clientHeight}px`
    } else {
      collapsibleElement.current.style.height = ''
    }

    typeof onExpandCollapse === 'function' && onExpandCollapse(collapsed)
  }, [collapsed])

  useEffect(() => {
    if (!collapsed) {
      collapsibleElement.current.style.height = 'auto'

      setTimeout(() => {
        collapsibleElement.current.style.height = `${collapsibleElement.current.clientHeight}px`
      }, 10)
    }
  }, [children])

  const classTrigger = classnames({
    'c-accordion__trigger': variant === ACCORDION_VARIANT_DEFAULT && collapsed,
    'c-accordion__trigger expanded':
      variant === ACCORDION_VARIANT_DEFAULT && !collapsed,
    'c-accordion__trigger-light':
      variant === ACCORDION_VARIANT_LIGHT && collapsed,
    'c-accordion__trigger-light expanded':
      variant === ACCORDION_VARIANT_LIGHT && !collapsed,
    'c-accordion__trigger-strong':
      variant === ACCORDION_VARIANT_STRONG && collapsed,
    'c-accordion__trigger-strong expanded':
      variant === ACCORDION_VARIANT_STRONG && !collapsed
  })

  return (
    <div
      className={classnames('c-accordion', className, {
        'c-accordion--collapsed': collapsed
      })}
    >
      <a className={classTrigger} onClick={handleClick}>
        <span data-mu-test={dataAttributeTest}>{label}</span>
      </a>
      {note && <span className='note p-left-thin'>{note}</span>}

      <div className='c-accordion__content' ref={collapsibleElement}>
        {children}
      </div>
    </div>
  )
}

Accordion.defaultProps = {
  defaultExpanded: false,
  variant: ACCORDION_VARIANT_DEFAULT,
  'data-mu-test': 'accordion'
}

Accordion.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  note: PropTypes.string,
  variant: PropTypes.oneOf([
    ACCORDION_VARIANT_DEFAULT,
    ACCORDION_VARIANT_LIGHT,
    ACCORDION_VARIANT_STRONG
  ]),
  onExpandCollapse: PropTypes.func,
  'data-mu-test': PropTypes.string
}
